import { contract } from 'lib/contract';

import * as page from './page';
import * as model from './model';
export { PagePrintMap } from './page';

contract({
  page,
  model
})